import { FloraTypography } from '@grupoboticario/flora-react';
import { CrossIcon } from '@grupoboticario/flora-react-icons';
import { DrawerHeader } from 'ui/components/compounds/Drawer/components/Drawer.components.styles';
import { CartStyles } from '../../Cart.styles';

type HeaderCartProps = {
  openUnavailableItems: boolean;
  handleClose: () => void;
  closeCart: () => void;
};

export const HeaderCart = ({ openUnavailableItems, handleClose, closeCart }: HeaderCartProps) => {
  return (
    <DrawerHeader.Component>
      <CartStyles.CloseButton
        data-close-cart="true"
        aria-label="Fechar carrinho"
        has="iconOnly"
        icon={<CrossIcon color="$1" size={24} />}
        onClick={openUnavailableItems ? handleClose : closeCart}
      />
      <FloraTypography as="h5" fontSize="subtitle" fontWeight="bold">
        Pedido atual
      </FloraTypography>
    </DrawerHeader.Component>
  );
};
